<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { SelectionItemProductTour } from '@enums/productTour.ts';
import { type SelectionItem } from '@models/selectionItem.ts';
import Button from '@components/Button.vue';
import Tooltip from '@components/Tooltip.vue';
import Typography from '@components/Typography.vue';
import { trans } from '@elements/translation';
import SelectionItemMinified from './SelectionItemMinified.vue';
import SelectionItemElement from './SelectionItemElement.vue';
import useSelectionItemStore from '../stores/useSelectionItemStore';

defineProps<{ selectionItem: SelectionItem }>();

const { firstItemId } = storeToRefs(useSelectionItemStore());
</script>

<template>
  <div class="selection-item-wrapper">
    <Tooltip panel-class="selection-item-wrapper__tooltip-panel">
      <template #trigger>
        <Button
          v-if="!selectionItem.is_removed"
          :id="selectionItem.id === firstItemId ? SelectionItemProductTour.TOUR_REORDER : undefined"
          class="selection-item-wrapper__drag-and-drop"
          variant="invisible"
        >
          <span class="selection-item-wrapper__drag-and-drop__icon" />
        </Button>
      </template>

      <template #panel>
        <Typography variant="body-small">
          {{ trans('selection_item.sort.tooltip') }}
        </Typography>
      </template>
    </Tooltip>

    <SelectionItemElement
      :id="`selection-item-${selectionItem.id}`"
      class="selection-item-wrapper__full"
      :selection-item="selectionItem"
    />

    <SelectionItemMinified
      class="selection-item-wrapper__minified"
      :selection-item="selectionItem"
    />
  </div>
</template>
